export default{
  problemaRaiz: null,
  morador: null,
  descricao: null,
  nomemorador: null,
  celular: null,
  telefone: null,
  cpf: null,
  empreendimentoid: null,
  empreendimentounidadeid: null,
  garantiaVistoria: false,
  manutencaogarantia: false,
  tecnicoid: null,
  dataSolicitacao: null,
  horario: null,
  email: null,
  patologia: [],
  apenasOrcamento: false,
  cortesia: false,
  garantia: false
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/addocurrence/data.js